import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessConfirmation = ({ email, mobile }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/student-dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        <div className="bg-card rounded-xl shadow-xl border border-border overflow-hidden">
          <div className="bg-gradient-to-r from-success/10 to-primary/10 px-6 py-8 md:px-8 md:py-12 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 md:w-24 md:h-24 bg-success/20 rounded-full mb-4 animate-in zoom-in duration-500">
              <Icon name="CheckCircle" size={48} color="var(--color-success)" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
              Registration Successful!
            </h1>
            <p className="text-base md:text-lg text-muted-foreground">
              Welcome to Studyexpo Virtual Education Fair
            </p>
          </div>

          <div className="p-6 md:p-8 space-y-6">
            <div className="bg-muted/50 rounded-lg p-4 md:p-6 space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Mail" size={20} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground mb-1">Email Confirmation Sent</h3>
                  <p className="text-sm text-muted-foreground break-words">
                    A confirmation email has been sent to <span className="font-medium text-foreground">{email}</span>
                  </p>
                </div>
                <Icon name="CheckCircle" size={20} color="var(--color-success)" />
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="MessageSquare" size={20} color="var(--color-success)" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground mb-1">WhatsApp Notification Sent</h3>
                  <p className="text-sm text-muted-foreground">
                    Welcome message sent to <span className="font-medium text-foreground">{mobile}</span>
                  </p>
                </div>
                <Icon name="CheckCircle" size={20} color="var(--color-success)" />
              </div>
            </div>

            <div className="bg-primary/5 rounded-lg p-4 md:p-6 border border-primary/20">
              <h3 className="font-semibold text-foreground mb-3 flex items-center gap-2">
                <Icon name="Sparkles" size={20} color="var(--color-primary)" />
                What's Next?
              </h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="Check" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  <span>Explore participating institutes and their virtual booths</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="Check" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  <span>Connect with institute representatives via live chat</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="Check" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  <span>Schedule video counseling sessions with your preferred institutes</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="Check" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  <span>Download brochures and application forms</span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                variant="default"
                size="lg"
                fullWidth
                onClick={() => navigate('/student-dashboard')}
                iconName="LayoutDashboard"
                iconPosition="left"
              >
                Go to Dashboard
              </Button>
              <Button
                variant="outline"
                size="lg"
                fullWidth
                onClick={() => navigate('/exhibition-hall')}
                iconName="Building2"
                iconPosition="left"
              >
                Explore Institutes
              </Button>
            </div>

            <p className="text-xs text-center text-muted-foreground">
              Redirecting to dashboard in 5 seconds...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessConfirmation;